module.exports = __webpack_public_path__ + "static/media/inclusion-villa-mobile.2922364f.webp";